import { isNullOrUndefined as isNoU, closest, SanitizeHtmlHelper } from '@syncfusion/ej2-base';
import * as events from '../base/constant';
import * as cls from '../base/css-constant';
/**
 * Kanban CRUD module
 */
export class Crud {
    /**
     * Constructor for CRUD module
     *
     * @param {Kanban} parent Accepts the kanban instance
     * @private
     */
    constructor(parent) {
        this.parent = parent;
    }
    addCard(cardData, index) {
        const args = {
            cancel: false, requestType: 'cardCreate', addedRecords: (cardData instanceof Array) ? cardData : [cardData],
            changedRecords: [], deletedRecords: []
        };
        this.parent.trigger(events.actionBegin, args, (addArgs) => {
            if (!addArgs.cancel) {
                let modifiedData = [];
                if (this.parent.sortSettings.field && this.parent.sortSettings.sortBy === 'Index') {
                    if (cardData instanceof Array) {
                        modifiedData = cardData;
                    }
                    else {
                        modifiedData.push(cardData);
                    }
                    modifiedData.forEach((data, index) => {
                        if (!data[this.parent.sortSettings.field]) {
                            const columnData = this.parent.getColumnData(data[this.parent.keyField]);
                            if (this.parent.sortSettings.direction === 'Ascending' && columnData.length > 0) {
                                data[this.parent.sortSettings.field] =
                                    (columnData[columnData.length - 1][this.parent.sortSettings.field]) + index + 1;
                            }
                            else if (this.parent.sortSettings.direction === 'Descending' && columnData.length > 0) {
                                data[this.parent.sortSettings.field] = columnData[0][this.parent.sortSettings.field] + index + 1;
                            }
                            if (columnData.length === 0) {
                                data[this.parent.sortSettings.field] = 1;
                            }
                        }
                    });
                    if (!(cardData instanceof Array)) {
                        if (!index && this.parent.sortSettings.direction === 'Descending') {
                            // eslint-disable-next-line max-len
                            this.parent.getColumnData(modifiedData[0][this.parent.keyField]).filter((obj, count) => {
                                if (obj[this.parent.sortSettings.field] === modifiedData[0][this.parent.sortSettings.field]) {
                                    index = count + 1;
                                }
                            });
                        }
                    }
                    if (index !== 0 && !index && this.parent.sortSettings.direction === 'Descending') {
                        index = 0;
                    }
                    modifiedData = this.priorityOrder(modifiedData, index);
                }
                if (this.parent.enableHtmlSanitizer) {
                    const field = this.parent.cardSettings.contentField;
                    if (this.parent.enableHtmlSanitizer && typeof field === 'string') {
                        cardData[field] =
                            SanitizeHtmlHelper.sanitize(cardData[field]);
                    }
                }
                const addedRecords = (cardData instanceof Array) ? cardData : [cardData];
                const changedRecords = (this.parent.sortSettings.field && this.parent.sortSettings.sortBy === 'Index') ? modifiedData : [];
                const editParms = { addedRecords: addedRecords, changedRecords: changedRecords, deletedRecords: [] };
                const type = (cardData instanceof Array || modifiedData.length > 0) ? 'batch' : 'insert';
                this.parent.dataModule.updateDataManager(type, editParms, 'cardCreated', cardData, index);
            }
        });
    }
    getIndexFromData(data) {
        const cardElement = this.parent.element.querySelector(`.${cls.CARD_CLASS}[data-id="${data[this.parent.cardSettings.headerField]}"]`);
        const element = closest(cardElement, '.' + cls.CONTENT_CELLS_CLASS);
        const index = [].slice.call(element.querySelectorAll('.' + cls.CARD_CLASS)).indexOf(cardElement);
        return index;
    }
    updateCard(cardData, index, isDropped, dataDropIndexKeyFieldValue, draggedKey, droppedKey, isMultipleDrag) {
        const args = {
            requestType: 'cardChange', cancel: false, addedRecords: [],
            changedRecords: (cardData instanceof Array) ? cardData : [cardData], deletedRecords: []
        };
        index = isNoU(index) ? this.getIndexFromData(args.changedRecords[0]) : index;
        this.parent.trigger(events.actionBegin, args, (updateArgs) => {
            if (!updateArgs.cancel) {
                if (this.parent.sortSettings.field && this.parent.sortSettings.sortBy === 'Index') {
                    let modifiedData = [];
                    if (cardData instanceof Array) {
                        modifiedData = cardData;
                    }
                    else {
                        modifiedData.push(cardData);
                    }
                    cardData = this.priorityOrder(modifiedData, index);
                }
                const editParms = {
                    addedRecords: [], changedRecords: (cardData instanceof Array) ? cardData : [cardData], deletedRecords: []
                };
                const type = (cardData instanceof Array) ? 'batch' : 'update';
                this.parent.dataModule.updateDataManager(type, editParms, 'cardChanged', cardData, index, isDropped, dataDropIndexKeyFieldValue, draggedKey, droppedKey, isMultipleDrag);
            }
        });
    }
    deleteCard(cardData) {
        const editParms = { addedRecords: [], changedRecords: [], deletedRecords: [] };
        if (typeof cardData === 'string' || typeof cardData === 'number') {
            editParms.deletedRecords = this.parent.kanbanData.filter((data) => data[this.parent.cardSettings.headerField] === cardData);
        }
        else {
            editParms.deletedRecords = (cardData instanceof Array) ? cardData : [cardData];
        }
        const args = {
            requestType: 'cardRemove', cancel: false, addedRecords: [], changedRecords: [], deletedRecords: editParms.deletedRecords
        };
        this.parent.trigger(events.actionBegin, args, (deleteArgs) => {
            if (!deleteArgs.cancel) {
                const type = (editParms.deletedRecords.length > 1) ? 'batch' : 'delete';
                const cardData = editParms.deletedRecords;
                this.parent.dataModule.updateDataManager(type, editParms, 'cardRemoved', cardData[0]);
            }
        });
    }
    priorityOrder(cardData, cardIndex) {
        const cardsId = cardData.map((obj) => obj[this.parent.cardSettings.headerField]);
        let num = cardData[cardData.length - 1][this.parent.sortSettings.field];
        const allModifiedKeys = cardData.map((obj) => obj[this.parent.keyField]);
        const modifiedKey = allModifiedKeys.filter((key, index) => allModifiedKeys.indexOf(key) === index).sort();
        let columnAllDatas;
        const finalData = [];
        const originalIndex = [];
        for (const columnKey of modifiedKey) {
            const keyData = cardData.filter((cardObj) => cardObj[this.parent.keyField] === columnKey);
            columnAllDatas = this.parent.enableVirtualization ? this.parent.virtualLayoutModule.getColumnData(columnKey)
                : this.parent.layoutModule.getColumnData(columnKey);
            for (const data of keyData) {
                if (this.parent.swimlaneSettings.keyField) {
                    const swimlaneDatas = this.parent.getSwimlaneData(data[this.parent.swimlaneSettings.keyField]);
                    columnAllDatas = this.parent.getColumnData(columnKey, swimlaneDatas);
                }
            }
            keyData.forEach((key) => finalData.push(key));
            if (!isNoU(cardIndex)) {
                for (let j = 0; j < cardsId.length; j++) {
                    columnAllDatas.filter((data, index) => {
                        if (data[this.parent.cardSettings.headerField] === cardsId[j] && index <= cardIndex) {
                            originalIndex.push(index);
                        }
                    });
                }
                if (originalIndex.length > 0) {
                    cardIndex = cardIndex + originalIndex.length;
                }
                if (this.parent.sortSettings.direction === 'Ascending') {
                    for (let i = cardIndex; i < columnAllDatas.length; i++) {
                        if (cardsId.indexOf(columnAllDatas[i][this.parent.cardSettings.headerField]) === -1) {
                            columnAllDatas[i][this.parent.sortSettings.field] = ++num;
                            finalData.push(columnAllDatas[i]);
                        }
                    }
                }
                else {
                    for (let i = cardIndex - 1; i >= 0; i--) {
                        if (cardsId.indexOf(columnAllDatas[i][this.parent.cardSettings.headerField]) === -1) {
                            columnAllDatas[i][this.parent.sortSettings.field] = ++num;
                            finalData.push(columnAllDatas[i]);
                        }
                    }
                }
            }
        }
        return finalData;
    }
}
